import { Injectable } from '@angular/core';

import { ScanResult, ScanService as DbaScanService, PrioritizingSubject } from '@definitiv-packages/angular-dba-library';

import { ScanPrefix } from '../../../../roofsafetymanagement-library/src/public-api';

@Injectable({
    providedIn: 'root'
})
export class ScanService {
    public safetyPoint: PrioritizingSubject<string> = new PrioritizingSubject();

    constructor(private scanService: DbaScanService) {
        this.scanService.scan.subscribe(scan => this.handleScan(scan));
    }

    private handleScan(scan: ScanResult): void {
        if (scan.Prefix == ScanPrefix.SafetyPointId) this.safetyPoint.next(scan.Text);
    }
}
